import { render, staticRenderFns } from "./tloanapply-add-or-updateloan.vue?vue&type=template&id=0d16fb69&scoped=true&"
import script from "./tloanapply-add-or-updateloan.vue?vue&type=script&lang=js&"
export * from "./tloanapply-add-or-updateloan.vue?vue&type=script&lang=js&"
import style0 from "./tloanapply-add-or-updateloan.vue?vue&type=style&index=0&id=0d16fb69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16fb69",
  null
  
)

export default component.exports